<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="abbrs">
<h1 class="ctfm"><a class="page" id="pix"></a><a class="xref" href="#/chilampert0006#rabbrs">Abbreviations</a></h1>
<table>
<tbody><tr>
<td>
<p class="td"><abbr><i>A</i> </abbr></p>
</td>
<td>
<p class="td"><i>The Antichrist</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>AOM</i> </abbr></p>
</td>
<td>
<p class="td"><i>Assorted Opinions and Maxims</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>BGE</i> </abbr></p>
</td>
<td>
<p class="td"><i>Beyond Good and Evil</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>BT</i> </abbr></p>
</td>
<td>
<p class="td"><i>The Birth of Tragedy</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>CW</i> </abbr></p>
</td>
<td>
<p class="td"><i>The Case of Wagner</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>D</i> </abbr></p>
</td>
<td>
<p class="td"><i>Daybreak</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>EH</i> </abbr></p>
</td>
<td>
<p class="td"><i>Ecce Homo</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>GM</i> </abbr></p>
</td>
<td>
<p class="td"><i>On the Genealogy of Morality</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>GS</i> </abbr></p>
</td>
<td>
<p class="td"><i>Gay Science</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>HH</i> </abbr></p>
</td>
<td>
<p class="td"><i>Things Human All Too Human</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>KGB</i> </abbr></p>
</td>
<td>
<p class="td"><i>Briefwechsel, Kritische Gesamtausgabe</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>KGW</i> </abbr></p>
</td>
<td>
<p class="td"><i>Kritische Gesamtausgabe</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>KSA</i> </abbr></p>
</td>
<td>
<p class="td"><i>Kritische Studienausgabe</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>KSB</i> </abbr></p>
</td>
<td>
<p class="td"><i>Sämtliche Briefe: Kritische Studienausgabe</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>NCW</i> </abbr></p>
</td>
<td>
<p class="td"><i>Nietzsche contra Wagner</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>PTA</i> </abbr></p>
</td>
<td>
<p class="td"><i>Philosophy in the Tragic Age of the Greeks</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>RWB</i> </abbr></p>
</td>
<td>
<p class="td"><i>Richard Wagner in Bayreuth</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>SE</i> </abbr></p>
</td>
<td>
<p class="td"><i>Schopenhauer as Educator</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>TI</i> </abbr></p>
</td>
<td>
<p class="td"><i>Twilight of the Idols</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><span class="gt">TL</span> </abbr></p>
</td>
<td>
<p class="td">“On Truth and Lie in the Extra-moral Sense”</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>UD</i> </abbr></p>
</td>
<td>
<p class="td"><i>On the Use and Disadvantage of History for Life</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>UM</i> </abbr></p>
</td>
<td>
<p class="td"><i>Untimely Meditations</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>WS</i> </abbr></p>
</td>
<td>
<p class="td"><i>The Wanderer and His Shadow</i></p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr><i>Z</i> </abbr></p>
</td>
<td>
<p class="td"><i>Thus Spoke Zarathustra</i></p>
</td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lampert-0007.vue?48038924